<template>
  <div class="productSystem">
    <div class="productSystem-title productSystem_box">产品体系</div>
    <div class="productSystem-content animated_changtu productSystem_box">
      <productSystemItem v-show="active_num == index" v-for="(item, index) in dataList" :key="index" :item="item">
      </productSystemItem>
    </div>
    <div class="productSystem-pagination">
      <img src="../../assets/image/left.png" alt="" @click="changeActiveNum('left')"
        class="productSystem-pagination-img">
      <div v-for="(item, index) in dataList" :key="index" class="productSystem-pagination-dian"
        :class="active_num == index ? 'productSystem-pagination-dian-active' : ''"></div>
      <img src="../../assets/image/right.png" alt="" @click="changeActiveNum('right')"
        class="productSystem-pagination-img">
    </div>
  </div>
  <div class="productSystem-mobile" v-if="dataList.length > 0">
    <ProductSystemMobile :dataList="dataList"></ProductSystemMobile>
  </div>
</template>

<script setup>
import productSystemItem from "./components/productSystemItem.vue"
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import ScrollReveal from 'scrollreveal'
import ProductSystemMobile from "./productSystemMobile.vue"

const dataList = ref([])

const active_num = ref(0)


const getData = async () => {
  let params = {
    page: 1,
    pageSize: 1000,
    sortField: "number68b2284b",
    isAsc: false,
    filters: [
      [
        {
          "dataType": 65,
          "field": "associationFields1cc234aa",
          "spliceType": 0,
          "values": [
            "680f497088d915058691fb72"
          ],
          "isDynamicSource": false,
          "dynamicSource": [],
          "filterType": 6
        }, {
          "dataType": 70,
          "field": "singleChoice4bec7ef2",
          "spliceType": 0,
          "values": [
            "1"
          ],
          "isDynamicSource": false,
          "dynamicSource": [],
          "filterType": 2
        }
      ]
    ],
    worksheetId: "680f487788d915058691f9f8",
  }
  const res = await getFilterList(params)
  if (res.code === 200 && res.data && res.data.length > 0) {
    let list = res.data.filter(item => item.input988275a1 !== '畅图云')

    dataList.value = list
  }
}
const changeActiveNum = (type) => {
  if (type == "left") {
    active_num.value--
    if (active_num.value < 0) {
      active_num.value = dataList.value.length - 1
    }
  } else {
    if (active_num.value === dataList.value.length - 1) {
      active_num.value = 0
    } else {
      active_num.value++
    }

  }
}

onMounted(() => {
  getData()
  const sr = ScrollReveal({
    distance: '50px',
    duration: 1000,
    delay: 300,
  })

  // 为每个元素配置不同的动画
  sr.reveal(".productSystem_box", {
    beforeReveal: (el) => {
      el.classList.add('animate__fadeInUp')
    },
  })
})

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
  .productSystem {
    display: none !important;
  }

  .productSystem-mobile {
    display: block;

  }

}



@media screen and (min-width: 800px) {
  .productSystem {
    display: flex !important;
  }

  .productSystem-mobile {
    display: none;
  }


}

.productSystem {
  font-family: 'PuHuiTi';
  width: 100%;
  height: 725px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.productSystem-title {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  margin: 30px 0;
}

.productSystem-content {
  width: 1400px;
  height: 596px;
  background: url("../../assets/image/productSystem_bg.png");
  border-radius: 20px;
  overflow: hidden;
}

.productSystem-pagination {
  display: flex;
  align-items: center;
  margin: 30px 0;
}

.productSystem-pagination-dian {
  width: 10px;
  height: 5px;
  border-radius: 5px;
  background-color: #999;
  margin: 0 10px;
}

.productSystem-pagination-dian-active {
  background-color: #333;
  width: 15px;
}

.productSystem-pagination-img {
  cursor: pointer;
}
</style>